import { array, defineAction, number, object, string } from '~/prix'
import appSebraeSearchAddressAction from './appSebraeSearchAddress.action.json' assert { type: 'json' }

const appSebraeSearchAddressDefinition = defineAction({
  ...appSebraeSearchAddressAction,
  operation: 'read' as const,
  input: object({
    address: string().label('Endereço parcial a ser pesquisado.'),
    number: string().isOptional().label('Número do endereço.'),
    latitude: number().isOptional().label('Latitude usada para resolver ou desempatar resultados.'),
    longitude: number()
      .isOptional()
      .label('Longitude usada para resolver ou desempatar resultados.'),
    limit: number().isOptional().label('Número máximo de resultados retornados.'),
  }),
  output: object({
    warnings: array(
      object({
        message: string(),
      }),
    ).isOptional(),
    results: array(
      object({
        displayAddress: string(),
        streetId: number(),
        streetName: string(),
        number: string().isOptional(),
        neighborhoodId: number().isOptional(),
        neighborhoodName: string().isOptional(),
        cityId: number(),
        cityName: string(),
        stateId: number(),
        stateAbbreviation: string(),
        latitude: number(),
        longitude: number(),
        quality: string(),
      }),
    ),
  }),
})

export default appSebraeSearchAddressDefinition
